<template>
    <div class="cta-container">
        <div class="cta-inner" :style="containerStyle">
            <show-more class="icon" :style="iconStyle" @click="toggle"/>
            <sign-up-component class="signup" @close="close"/>
        </div>
    </div>
</template>

<script>
import ShowMore from '@/assets/svg/baseline-expand_less-24px.svg'
import SignUpComponent from '@/components/SignUpComponent'
import { sceneData } from '@/util/sceneMap'
import { transform } from 'popmotion'
import updateOnScroll from 'uos'

export default {
    components: {
        ShowMore,
        SignUpComponent
    },

    data() {
        return {
            open: false,
            progress: 0
        }
    },

    computed: {
        containerStyle() {
            if (this.open) {
                return { transform: 'translateY(0)' }
            } else {
                return { transform: 'translateY(98%)' }
            }
        },

        iconStyle() {
            if (this.open) {
                return {
                    transform: 'translate(-50%, 0) rotateX(180deg)'
                }
            } else {
                return {
                    transform: 'translate(-50%, -100%) rotateX(0)'
                }
            }
        }
    },

    watch: {
        progress(p, op) {
            if (p > 0.9) {
                this.open = true
            } else if (p < 0.7 && op >= 0.7) {
                this.open = false
            }
        }
    },

    created() {
        let [start, end] = sceneData.overview.scrollProgress
        this.uos = updateOnScroll(start, end, progress => {
            this.progress = progress
        })
    },

    beforeDestroy() {
        this.uos()
    },

    methods: {
        toggle() {
            this.open = !this.open
        },

        close() {
            this.open = false
        }
    }
}
</script>

<style lang="stylus" scoped>
.cta-container
    position: fixed
    bottom: 0
    left: 0
    width: 100%
    height: 33%
    pointer-events: all
    cursor: default

.cta-inner
    width: 100%
    height: 100%
    background-color: rgba(20, 20, 20, 0.8)
    transition: transform 0.5s
    border-top: 1px solid sd-beige

.icon
    position: absolute
    width: 48px
    height: 48px
    left: 50%
    fill: white
    transition: transform 0.3s
    cursor: pointer

.signup
    width: 100%
    height: 100%
    padding-top: 48px
    padding-bottom: 24px
    box-sizing: border-box
</style>
